module.exports = __webpack_public_path__ + "img/icon.4e3458f3.svg";